export default [
  {
    path: '/fakta',
    name: 'Fakta',
    component: () =>
      import(/* webpackChunkName: "Facts" */ '../views/Fakta.vue')
  },
  {
    path: '/fakta/att-leva-i-havet',
    name: 'att-leva-i-havet',
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "LivsmiljoerChild" */ '../views/PageChild.vue'
      ),
    meta: { pageId: 281, scrollTop: true, factName: 'Att leva i havet' }
  },
  {
    path: '/fakta/ostersjons-historia',
    name: 'ostersjons-historia',
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "LivsmiljoerChild" */ '../views/PageChild.vue'
      ),
    meta: { pageId: 3534, scrollTop: true, factName: 'Östersjöns historia' }
  },
  {
    path: '/fakta/varken-salt-eller-sott',
    name: 'varken-salt-eller-sott',
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "LivsmiljoerChild" */ '../views/PageChild.vue'
      ),
    meta: { pageId: 3535, scrollTop: true, factName: 'Salt och sött' }
  },
  {
    path: '/fakta/vem-ater-vem',
    name: 'vem-ater-vem',
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "LivsmiljoerChild" */ '../views/PageChild.vue'
      ),
    meta: { pageId: 3536, scrollTop: true, factName: 'Vem äter vem' }
  },
  {
    path: '/fakta/vem-lever-var',
    name: 'vem-lever-var',
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "LivsmiljoerChild" */ '../views/PageChild.vue'
      ),
    meta: { pageId: 3537, scrollTop: true, factName: 'Vem lever var' }
  }
]
